import { Workbook } from "exceljs";
import {
  excelHelper,
  fileHelper,
  formatHelper,
} from "../../../../common/helpers";
/**
 *
 * @param {any[]} employeeBalance
 * @returns {Workbook}
 */
export const exportExcel = async (
  employeeBalance,
  selectedStore,
  startDate,
  endDate
) => {
  let totalIncomeServices = 0;
  let totalIncomeProducts = 0;
  let totalIncomeOffers = 0;
  let totalIncome = 0;

  const excelData = [];
  for (let item = 0; item < employeeBalance.length; item++) {
    const balance = employeeBalance[item];

    excelData.push({
      order: item + 1,
      name: `${balance.name} ${balance.lastname}`,
      totalSoldServices: balance.totalSoldServices,
      totalSoldProducts: balance.totalSoldProducts,
      totalSoldOffers: balance.totalSoldOffers,
      totalSold: balance.totalSold,
    });

    totalIncomeServices += balance.totalSoldServices;
    totalIncomeOffers += balance.totalSoldOffers;
    totalIncomeProducts += balance.totalSoldProducts;
    totalIncome += balance.totalSold;
  }

  excelData.push({
    order: "",
    name: "TOTAL",
    totalSoldServices: totalIncomeServices,
    totalSoldProducts: totalIncomeProducts,
    totalSoldOffers: totalIncomeOffers,
    totalSold: totalIncome,
  });

  const json = excelHelper.jsonToJson(
    [excelData],
    [
      {
        name: "BALANCE POR EMPLEADOS",
        props: [
          {
            inValue: "order",
            outValue: "",
          },
          {
            inValue: "name",
            outValue: "EMPLEADO",
          },
          {
            inValue: "totalSoldServices",
            outValue: "TOTAL RECAUDADO SERVICIOS",
          },
          {
            inValue: "totalSoldProducts",
            outValue: "TOTAL RECAUDADO PRODUCTOS",
          },
          {
            inValue: "totalSoldOffers",
            outValue: "TOTAL RECAUDADO OFERTAS",
          },
          {
            inValue: "totalSold",
            outValue: "TOTAL RECAUDADO",
          },
        ],
      },
    ]
  );
  const workbook = excelHelper.jsonToExcelJs(json);
  const fileName = getFileName(selectedStore, startDate, endDate);
  const blob = await excelHelper.workbookToBlob(workbook);
  fileHelper.downloadBlob(blob, fileName);
};

const getFileName = (selectedStore, startDate, endDate) => {
  const storeName = selectedStore.label;
  return selectedStore.value == 0
    ? formatHelper.toDateYYMMDD(startDate._d) +
        "_" +
        formatHelper.toDateYYMMDD(endDate._d) +
        "_reporte-general-balance-por-empleado" +
        ".xlsx"
    : storeName.toLowerCase() +
        "_" +
        formatHelper.toDateYYMMDD(startDate._d) +
        "_" +
        formatHelper.toDateYYMMDD(endDate._d) +
        "_reporte-balance-por-empleado" +
        ".xlsx";
};



// WEBPACK FOOTER //
// ./src/scenes/Report/Cash/EmployeesBalance/excel.js